window.TGS = window.TGS || {};

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-accordion-toggle]');
  if (!btn) return;
  const item = btn.closest('.tgs-accordion__item');
  const root = btn.closest('[data-accordion]');
  const wasOpen = item.hasAttribute('data-open');
  root.querySelectorAll('.tgs-accordion__item[data-open]').forEach((el) => { el.removeAttribute('data-open'); el.querySelector('[data-accordion-toggle]').setAttribute('aria-expanded', 'false'); });
  if (!wasOpen) { item.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
});

document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-menu-toggle]');
  if (!t) return;
  const nav = document.querySelector('[data-mobile-nav]');
  const open = t.getAttribute('aria-expanded') === 'true';
  t.setAttribute('aria-expanded', String(!open));
  nav.hidden = open;
});

(() => {
  const R = window.TGS_ROUTES;
  let lastFocused = null;
  let busy = false;
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const showError = () => { const el = document.querySelector('[data-cart-error]'); if (el) el.classList.remove('tgs-hidden'); };
  const replaceDrawer = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer]');
    const cur = drawer();
    if (next && cur) { const open = cur.classList.contains('is-open'); cur.replaceWith(next); if (open) next.classList.add('is-open'); }
  };
  const syncCount = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.toggle('tgs-hidden', cart.item_count === 0); });
    document.dispatchEvent(new CustomEvent('tgs:cart-updated', { detail: { cart } }));
  };
  const openCart = () => {
    const d = drawer(); if (!d) return;
    lastFocused = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('tgs-lock');
    const closeBtn = d.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  };
  const closeCart = () => {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('tgs-lock');
    const target = lastFocused || document.querySelector('[data-cart-open]');
    if (target) target.focus();
    lastFocused = null;
  };
  const refresh = async () => {
    const [html, cart] = await Promise.all([
      fetch(`${R.cart}?sections=cart-drawer`).then((r) => r.json()).then((j) => j['cart-drawer']),
      fetch(`${R.cart}.js`).then((r) => r.json()),
    ]);
    replaceDrawer(html); syncCount(cart);
  };
  const addToCart = async (form, opts = {}) => {
    if (busy) return;
    busy = true;
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    const btn = form.querySelector('[type="submit"]');
    const bn = form.querySelector('[data-buy-now]');
    if (btn) btn.disabled = true;
    if (bn) bn.disabled = true;
    try {
      const res = await fetch(`${R.cartAdd}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('add failed');
      const json = await res.json();
      if (opts.buyNow) { window.location.href = R.checkout; return; }
      replaceDrawer(json.sections['cart-drawer']);
      const cart = await fetch(`${R.cart}.js`).then((r) => r.json());
      syncCount(cart); openCart();
    } catch (err) { showError(); openCart(); }
    finally { if (btn) btn.disabled = false; if (bn) bn.disabled = false; busy = false; }
  };
  const changeLine = async (key, quantity) => {
    try {
      const res = await fetch(`${R.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer' }) });
      if (!res.ok) throw new Error('change failed');
      const json = await res.json();
      replaceDrawer(json.sections['cart-drawer']); syncCount(json);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) { showError(); }
  };
  window.TGS = Object.assign(window.TGS || {}, { openCart, closeCart, addToCart, changeLine, refreshCart: refresh });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const q = e.target.closest('[data-line-qty]');
    if (q) { const line = q.closest('[data-line]'); changeLine(line.dataset.lineKey, Math.max(0, parseInt(q.dataset.lineQty, 10))); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.tgs-pdp__form');
    if (!form) return;
    e.preventDefault();
    addToCart(form, { buyNow: form.dataset.buyNow === 'true' });
    delete form.dataset.buyNow;
  });
})();

document.addEventListener('click', (e) => {
  const pill = e.target.closest('.tgs-pill');
  if (!pill) return;
  const root = pill.closest('[data-collection]');
  const mood = pill.dataset.filter;
  root.querySelectorAll('.tgs-pill').forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));
  let n = 0;
  root.querySelectorAll('[data-product-card]').forEach((card) => { const show = !mood || card.dataset.mood === mood; card.classList.toggle('tgs-hidden', !show); if (show) n++; });
  const count = root.querySelector('[data-count]');
  count.textContent = (n === 1 ? count.dataset.one : count.dataset.other).replace('#', n);
  root.querySelector('[data-empty]').classList.toggle('tgs-hidden', n > 0);
});

document.addEventListener('click', (e) => {
  const th = e.target.closest('[data-gallery-thumb]');
  if (th) { const g = th.closest('[data-gallery]'); const main = g.querySelector('.tgs-pdp__main img'); main.src = th.dataset.src; main.srcset = th.dataset.srcset; g.querySelectorAll('[data-gallery-thumb]').forEach((b) => b.setAttribute('aria-pressed', String(b === th))); return; }
  const st = e.target.closest('[data-step]');
  if (st) { const input = st.closest('[data-stepper]').querySelector('input'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(st.dataset.step, 10)); return; }
  const bn = e.target.closest('button[data-buy-now]');
  if (bn) { const form = bn.closest('form'); form.dataset.buyNow = 'true'; form.requestSubmit(); }
});
